import { useEffect, useState, type ComponentProps } from 'react';
import { ChartLibraryPicker } from '@lognai/plugin-analytics-ui';
import { WorkspaceAiButton, WorkspaceAiCreator, type WorkspaceAiOptions } from './WorkspaceAiCreator';

/**
 * The workspace and dashboard editor share the same visual library; the workspace
 * adds "Create with AI", which swaps the library for the AI creator in the same dialog.
 */
export function ChartCardPicker({
  ai,
  ...props
}: Omit<ComponentProps<typeof ChartLibraryPicker>, 'headerAction' | 'content'> & { ai: WorkspaceAiOptions }) {
  const [aiMode, setAiMode] = useState(false);
  useEffect(() => { if (!props.open) setAiMode(false); }, [props.open]);
  return (
    <ChartLibraryPicker
      {...props}
      headerAction={<WorkspaceAiButton onClick={() => setAiMode(true)} />}
      content={aiMode ? <WorkspaceAiCreator kind="chart" {...ai} onBack={() => setAiMode(false)} onClose={() => props.onOpenChange(false)} /> : undefined}
    />
  );
}
